export default "__VITE_ASSET__CESROemF__"